import { ComponentType } from "preact";
import { connect } from "react-redux";

import withTransformedProps from "../../withTransformedProps";

import AITweak from "./AITweak";
import { mapStateToProps, mapDispatchToProps, transformProps } from "./AITweakMapper";
import { OwnProps } from "./AITweakProps";

export default connect(mapStateToProps, mapDispatchToProps)(
    withTransformedProps(AITweak, transformProps)
) as ComponentType<OwnProps>;
